import { Field, FormItem } from '#/common/components/Form';
import { getUser } from '#/graphql/queries';
import { Key } from '#/types';
import { gql } from '@apollo/client';
import _ from 'lodash';
import { UserRole } from '#/common/types/userTypes';

type FieldOptions<T> = Partial<Field<T>>;

const fieldGetters: Record<string, <T>(options?: FieldOptions<T>) => Field<T>> = {
  createdAt: <T>({ dataField = 'createdAt' as Key<T> }: FieldOptions<T> = {}) => ({
    dataField: dataField,
    label: 'Created At',
    editorType: 'DateBox',
    editorOptions: {
      type: 'datetime',
      readOnly: true,
    },
  }),
  createdBy: <T>({ dataField = 'createdBy' as Key<T> }: FieldOptions<T> = {}) => ({
    dataField: dataField,
    label: 'Created By',
    editorType: 'RelatedItems',
    editorOptions: {
      button: {
        tooltip: 'View user details',
        url: '/admin/users/:value/details',
        desktopOnly: false,
        enabledForRoles: [UserRole.trane_admin],
      },
      readOnly: true,
      displayExpr: 'name',
      valueExpr: 'id',
      searchEnabled: false,
      dataStoreOptions: {
        getItem: gql(getUser),
      },
    },
  }),
  updatedAt: <T>({ dataField = 'updatedAt' as Key<T> }: FieldOptions<T> = {}) => ({
    dataField: dataField,
    label: 'Updated At',
    editorType: 'DateBox',
    editorOptions: {
      type: 'datetime',
      readOnly: true,
    },
  }),
  updatedBy: <T>({ dataField = 'updatedBy' as Key<T> }: FieldOptions<T> = {}) => ({
    dataField: dataField,
    label: 'Updated By',
    editorType: 'RelatedItems',
    editorOptions: {
      button: {
        tooltip: 'View user details',
        url: '/admin/users/:value/details',
        desktopOnly: false,
        enabledForRoles: [UserRole.trane_admin],
      },
      readOnly: true,
      displayExpr: 'name',
      valueExpr: 'id',
      searchEnabled: false,
      dataStoreOptions: {
        getItem: gql(getUser),
      },
    },
  }),
};

export const getHistoryFieldNames = (): string[] => {
  return Object.keys(fieldGetters);
};

export type FieldsOptions<T> = {} & FormItem<T> & {
    createdAt?: FieldOptions<T>;
    createdBy?: FieldOptions<T>;
    updatedAt?: FieldOptions<T>;
    updatedBy?: FieldOptions<T>;
  };

export const getHistorySection = <T>(options: FieldsOptions<T> = {}): FormItem<T> =>
  _.merge(
    {
      cssClass: 'tmm-section',
      caption: 'History',
      colCount: {
        xs: 1,
        sm: 1,
        md: 4,
        lg: 4,
      },
      items: [
        fieldGetters.createdAt(options.createdAt),
        fieldGetters.createdBy(options.createdBy),
        fieldGetters.updatedAt(options.updatedAt),
        fieldGetters.updatedBy(options.updatedBy),
      ],
    },
    { ...options },
  );
